<div class="content-wrapper">
  <div class="container-xxl flex-grow-1 container-p-y">
    <h4 class="fw-bold py-3 " style="font-size: 17px;margin-left:20px; margin-top: 0.5cm;">
      <span class="text-muted fw-light">Payments /</span> Payments Link
    </h4>
    <mat-card>
      <mat-card-header class="mt-3 mb-4">
        <span class="material-icons" style="margin-right:10px ;">
          attach_file
        </span>Create Payment Link
      </mat-card-header>

      <hr class="my-0 mt-3 mb-3" />

      <mat-card-content>
        <form [formGroup]="businessTypeForm" (ngSubmit)="onSubmit()">
          <mat-card class="mt-3 mb-3">
            <mat-card-header class="mb-4 mt-2">
              <mat-icon class="nav-icon">business</mat-icon> Business Type
            </mat-card-header>

            <mat-card-content>
              <div class="row">
                <div class="col-md-3">
                  <div class="adminControls">
                    <mat-form-field appearance="outline">
                      <mat-label>Service Date</mat-label>
                      <input matInput [matDatepicker]="dp" placeholder="Select Date" formControlName="ServiceDate"
                        [ngClass]="{'is-invalid':submitted && forms.ServiceDate.errors}">
                      <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
                      <mat-datepicker #dp></mat-datepicker>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                      <mat-label>Service Charge</mat-label>
                      <input type="number" matInput formControlName="ServiceCharge" (keypress)="numberOnly($event)"
                        [ngClass]="{'is-invalid':submitted && forms.ServiceCharge.errors}" required autocomplete="off">
                      <mat-error *ngIf="submitted && forms.ServiceCharge.errors" class="invalid-feedback">
                        <div *ngIf="forms.ServiceCharge.errors.required"> This field is required </div>
                        <div *ngIf="forms.ServiceCharge.errors.incorrect"> Please enter valid amount </div>
                      </mat-error>
                    </mat-form-field>
                    <p class="ServiceCharge-desc">Service will be in US Dollars($)</p>
                  </div>
                </div>
                <!-- {{this.businessTypeForm.value.ServiceDate}} -->
                <div class="col-md-3">
                  <div class="adminControls">
                    <mat-form-field appearance="outline">
                      <mat-label>Service Type</mat-label>
                      <mat-select formControlName="serviceType" name="serviceType" id="serviceType"
                        [ngClass]="{'is-invalid':submitted && forms.serviceType.errors}" required>
                        <mat-option *ngFor="let serviceTypes of PaymentServiceTypes"
                          [value]="serviceTypes.paymentServiceTypeId">
                          {{ serviceTypes.serviceType }}
                        </mat-option>
                      </mat-select>
                      <mat-error *ngIf="submitted && forms.serviceType.errors" class="invalid-feedback">
                        <div *ngIf="forms.serviceType.errors.required"> This field is required </div>
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
                <!-- <div class="col-md-3">
                  <div class="adminControls">
                    <mat-form-field appearance="outline">
                      <mat-label>Service Type</mat-label>
                      <mat-select formControlName="serviceType">
                        <mat-option value="A">Application Fee</mat-option>
                        <mat-option value="B">Appraisal Fee Service</mat-option>
                        <mat-option value="C">Credit Report Fee</mat-option>
                        <mat-option value="D">VA Funding Fee</mat-option>
                      </mat-select>
                      <mat-error>This feild is required</mat-error>
                    </mat-form-field>
                  </div>
                </div> -->

                <div class="col-md-3">
                  <div class="adminControls">
                    <mat-form-field appearance="outline">
                      <mat-label>Service Code</mat-label>
                      <input matInput formControlName="ServiceCode"
                        [ngClass]="{'is-invalid':submitted && forms.ServiceCode.errors}" required>
                      <mat-error *ngIf="submitted && forms.ServiceCode.errors" class="invalid-feedback">
                        <div *ngIf="forms.ServiceCode.errors.required"> This field is required </div>
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>

                <div class="col-md-3">
                  <div class="adminControls">
                    <mat-form-field appearance="outline">
                      <mat-label>Service Description</mat-label>
                      <input matInput formControlName="ServiceDescription"
                        [ngClass]="{'is-invalid':submitted && forms.ServiceDescription.errors}" required>
                      <mat-error *ngIf="submitted && forms.ServiceDescription.errors" class="invalid-feedback">
                        <div *ngIf="forms.ServiceDescription.errors.required"> This field is required </div>
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </mat-card-content>
          </mat-card>


          <mat-card class="mb-3">
            <mat-card-header class="mb-4 mt-2">
              <mat-icon class="nav-icon">assignment</mat-icon>
              <label *ngIf="containsAgent()">Service Information</label>
              <label *ngIf="!containsAgent()">Property Information</label>
              <!-- <mat-icon class="nav-icon">assignment</mat-icon> Property Information -->
            </mat-card-header>
            <mat-card-content>
              <div class="row">
                <div class="col-md-3">
                  <div class="adminControls">
                    <mat-form-field appearance="outline">
                      <mat-label>Vendor</mat-label>
                      <mat-select id="VendorId" formControlName="VendorId" name="VendorId"
                        [ngClass]="{'is-invalid':submitted && forms.VendorId.errors}" required>
                        <mat-option *ngFor="let data of this.data" [value]="data">{{ data }}</mat-option>
                      </mat-select>
                      <mat-error *ngIf="submitted && forms.VendorId.errors" class="invalid-feedback">
                        <div *ngIf="forms.VendorId.errors.required"> This field is required </div>
                      </mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                      <mat-label>Zipcode</mat-label>
                      <input matInput formControlName="PropertyAddressZip" (keypress)="numberOnly($event)"
                        [ngClass]="{'is-invalid':submitted && forms.PropertyAddressZip.errors}" appNumericOnly
                        appNumeric autocomplete="doNotAutoComplete" (input)="onZipCodeChange($event)" required>
                      <mat-error *ngIf="submitted  && forms.PropertyAddressZip.errors" class="invalid-feedback">
                        <div *ngIf="forms.PropertyAddressZip.errors.required">ZipCode is required</div>
                        <div *ngIf="forms.PropertyAddressZip.errors.minlength">Mininmum length is 5</div>
                        <div *ngIf="forms.PropertyAddressZip.errors.maxlength">Maximum length is 5</div>
                      </mat-error>
                    </mat-form-field>


                  </div>
                </div>
                <div class="col-md-3">
                  <div class="adminControls">

                    <mat-form-field appearance="outline">
                      <mat-label>Street</mat-label>
                      <input matInput formControlName="PropertyAddressStreet"
                        [ngClass]="{'is-invalid':submitted && forms.PropertyAddressStreet.errors}" required>
                      <mat-error *ngIf="submitted && forms.PropertyAddressStreet.errors" class="invalid-feedback">
                        <div *ngIf="forms.PropertyAddressStreet.errors.required"> This field is required </div>
                      </mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                      <mat-label>State</mat-label>
                      <!-- <input matInput formControlName="PropertyAddressState" name="PropertyAddressState"
                      id="PropertyAddressState" (selectionChange)="onStateClick($event)"
                      [ngClass]="{'is-invalid':submitted && forms.PropertyAddressState.errors}" required>     -->
                      <mat-select formControlName="PropertyAddressState" name="PropertyAddressState"
                        id="PropertyAddressState"
                        [ngClass]="{'is-invalid':submitted && forms.PropertyAddressState.errors}" required>
                        <mat-option *ngFor="let State of states" [value]="State">
                          {{ State }}
                        </mat-option>
                      </mat-select>
                      <mat-error *ngIf="submitted && forms.PropertyAddressState.errors" class="invalid-feedback">
                        <div *ngIf="forms.PropertyAddressState.errors.required"> This field is required </div>
                        <!-- <div *ngIf="forms.PropertyAddressState.errors.maxlength">Maximum length is 2</div> -->
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>

                <div class="col-md-3">
                  <div class="adminControls">
                    <mat-form-field appearance="outline">
                      <mat-label>Landmark</mat-label>
                      <input matInput formControlName="payeeLandmark">
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                      <mat-label>City</mat-label>
                      <!-- <input matInput formControlName="PropertyAddressCity" name="PropertyAddressCity"
                        id="PropertyAddressCity" required
                        [ngClass]="{'is-invalid':submitted && forms.PropertyAddressCity.errors}"> -->

                      <mat-select formControlName="PropertyAddressCity" name="PropertyAddressCity"
                        id="PropertyAddressCity" required
                        [ngClass]="{'is-invalid':submitted && forms.PropertyAddressCity.errors}">
                        <mat-option *ngFor="let City of cities" [value]="City">
                          {{ City }}
                        </mat-option>
                      </mat-select>
                      <mat-error *ngIf="submitted && forms.PropertyAddressCity.errors" class="invalid-feedback">
                        <div *ngIf="forms.PropertyAddressCity.errors.required"> This field is required </div>
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>


                <div class="col-md-3">
                  <div class="adminControls">
                    <mat-form-field appearance="outline">
                      <mat-label>Loan ID</mat-label>
                      <input matInput formControlName="LoanId"
                        [ngClass]="{'is-invalid':submitted && forms.LoanId.errors}" required>
                      <mat-error *ngIf="submitted && forms.LoanId.errors" class="invalid-feedback">
                        <div *ngIf="forms.LoanId.errors.required"> This field is required </div>
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </mat-card-content>
          </mat-card>

          <mat-card class="mt-3">
            <mat-card-header class="mb-4 mt-2">
              <mat-icon class="nav-icon">person</mat-icon> Payee Information
            </mat-card-header>
            <mat-card-content>
              <div class="row">
                <div class="col-md-3">
                  <div class="adminControls">

                    <mat-form-field appearance="outline">
                      <mat-label>First Name</mat-label>
                      <input matInput formControlName="PayeeNameFirst"
                        [ngClass]="{'is-invalid':submitted && forms.PayeeNameFirst.errors}" required>
                      <mat-error *ngIf="submitted && forms.PayeeNameFirst.errors" class="invalid-feedback">
                        <div *ngIf="forms.PayeeNameFirst.errors.required"> This field is required </div>
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="adminControls">
                    <mat-form-field appearance="outline">
                      <mat-label>Last Name</mat-label>
                      <input matInput formControlName="PayeeNameLast"
                        [ngClass]="{'is-invalid':submitted && forms.PayeeNameLast.errors}" required>
                      <mat-error *ngIf="submitted && forms.PayeeNameLast.errors" class="invalid-feedback">
                        <div *ngIf="forms.PayeeNameLast.errors.required"> This field is required </div>
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="adminControls">
                    <mat-form-field appearance="outline">
                      <mat-label>Phone Number</mat-label>
                      <input matInput formControlName="PayeePhone" (keypress)="onPress($event)"
                        [ngClass]="{'is-invalid':submitted && forms.PayeePhone.errors}" placeholder="XXX-XXX-XXXX"
                        required autocomplete="doNotAutoComplete" appPhoneMask appNumericOnly>
                      <mat-error *ngIf="submitted && forms.PayeePhone.errors" class="invalid-feedback">
                        <div *ngIf="forms.PayeePhone.errors.required">Phone Number is required
                        </div>
                        <div *ngIf="forms.PayeePhone.errors.pattern">Please, Enter 10 digit Mobile
                          Number</div>
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="adminControls">

                    <mat-form-field appearance="outline">
                      <mat-label>Email</mat-label>
                      <input matInput formControlName="PayeeEmail" id="PayeeEmail" name="PayeeEmail"
                        [ngClass]="{'is-invalid' : submitted && forms.PayeeEmail.errors}" required>
                      <mat-error *ngIf="submitted && forms.PayeeEmail.errors" class="invalid-feedback">
                        <div *ngIf="forms.PayeeEmail.errors.required"> This feild is required
                        </div>
                        <div *ngIf="forms.PayeeEmail.errors.email">Email must be a valid email
                          address</div>
                        <div *ngIf="forms.PayeeEmail.errors.pattern">The Email is not valid
                          email address
                        </div>
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </mat-card-content>
          </mat-card>

          <mat-card class="mt-3">
            <mat-card-header>
              <mat-icon class="nav-icon">task</mat-icon> Confirmation
            </mat-card-header>
            <div class="mb-3 col-lg-12 mt-4 mb-4">
              <div class="pricinginfo" style="margin-left: 40px;">
                <p class="mb-0"><span class="fw-bold">Vendor Name : </span><span class="c-green">
                    {{this.businessTypeForm.value.VendorId}}
                  </span></p>
                <p class="mb-0"><span class="fw-bold">Service Name : </span><span class="c-green">
                    {{this.businessTypeForm.value.ServiceCode}}</span></p>
                <p class="mb-0"><span class="fw-bold">Service Description : </span><span> M/S
                    {{this.businessTypeForm.value.PayeeNameFirst}} for propery at
                    {{this.businessTypeForm.value.ServiceDescription}}</span>
                <p class="mb-0"><span class="fw-bold" style="color: rgb(218, 53, 8);">Service Charging Amount :
                  </span><span style="color: rgb(218, 53, 8);">${{this.businessTypeForm.value.ServiceCharge}}</span></p>
                <br>

              </div>
            </div>
            <alert></alert>
            <div class="buttonRow mb-3" style="margin-left: 40px;">
              <button mat-raised-button class="button" type="submit" style="margin-right:10px">Create</button>
              <button mat-raised-button color="basic" class="buttonReset" type="reset">Cancel</button>
            </div>
          </mat-card>
        </form>
      </mat-card-content>
    </mat-card>
  </div>
</div>